import { jsxs as v, jsx as o, Fragment as j } from "react/jsx-runtime";
import * as s from "react";
import { memo as z, useState as B } from "react";
import { Button as a, Popconfirm as V } from "antd";
import { R as C } from "../../../DeleteOutlined-DKErSiw6.js";
import { R as I } from "../../../CloseOutlined-CEtTmi9p.js";
import { I as g } from "../../../AntdIcon-DR2yozD3.js";
var N = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, name: "edit", theme: "outlined" };
function d() {
  return d = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var c = arguments[t];
      for (var n in c)
        Object.prototype.hasOwnProperty.call(c, n) && (e[n] = c[n]);
    }
    return e;
  }, d.apply(this, arguments);
}
const w = (e, t) => /* @__PURE__ */ s.createElement(g, d({}, e, {
  ref: t,
  icon: N
})), O = /* @__PURE__ */ s.forwardRef(w);
process.env.NODE_ENV !== "production" && (O.displayName = "EditOutlined");
var $ = { icon: { tag: "svg", attrs: { viewBox: "64 64 896 896", focusable: "false" }, children: [{ tag: "path", attrs: { d: "M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z" } }] }, name: "save", theme: "outlined" };
function f() {
  return f = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var c = arguments[t];
      for (var n in c)
        Object.prototype.hasOwnProperty.call(c, n) && (e[n] = c[n]);
    }
    return e;
  }, f.apply(this, arguments);
}
const y = (e, t) => /* @__PURE__ */ s.createElement(g, f({}, e, {
  ref: t,
  icon: $
})), b = /* @__PURE__ */ s.forwardRef(y);
process.env.NODE_ENV !== "production" && (b.displayName = "SaveOutlined");
const L = {
  type: "primary",
  className: "at-mx-1"
}, P = ({
  canDelete: e = !0,
  buttonProps: t = {},
  className: c,
  type: n = "both",
  onDelete: E,
  onSave: x,
  onEdit: m,
  onCancel: u
}) => {
  const [h, p] = B(!1), l = {
    edit: {
      children: "編輯",
      onClick: () => {
        p(!0), m && m();
      },
      icon: /* @__PURE__ */ o(O, {})
    },
    save: {
      children: "儲存",
      icon: /* @__PURE__ */ o(b, {}),
      onClick: x
    },
    cancel: {
      children: "取消",
      onClick: () => {
        p(!1), u && u();
      },
      icon: /* @__PURE__ */ o(I, {}),
      type: "default"
    },
    delete: {
      children: "刪除",
      danger: !0,
      icon: /* @__PURE__ */ o(C, {})
    }
  }, i = (R) => {
    const r = {
      ...L,
      ...t,
      ...(l == null ? void 0 : l[R]) || {}
    };
    return n === "both" ? r : n === "icon" ? (delete r.children, r) : (n === "text" && delete r.icon, r);
  };
  return /* @__PURE__ */ v("div", { className: c, children: [
    !h && /* @__PURE__ */ o(a, { ...i("edit") }),
    h && /* @__PURE__ */ v(j, { children: [
      /* @__PURE__ */ o(a, { ...i("save") }),
      /* @__PURE__ */ o(a, { ...i("cancel") })
    ] }),
    e && /* @__PURE__ */ o(
      V,
      {
        title: "Confirm delete",
        onConfirm: E,
        okText: "confirm",
        cancelText: "cancel",
        children: /* @__PURE__ */ o(a, { ...i("delete") })
      }
    )
  ] });
}, k = z(P);
export {
  k as ActionButton
};
